import React from "react"
import TmsDashboard from "./components/TmsDashboard"
import ComponentWrapper from "../../common/components/ComponentWrapper"

function tmsStartPage() {
	return (
		<div>
			<ComponentWrapper active={3} subMenuActive={1}>
				<h1 className='dashboard__header'>Dashboard</h1>
				<TmsDashboard />
			</ComponentWrapper>
		</div>
	)
}

export default tmsStartPage
